/**
 * Aggregate calculation version health for one assessment period.
 * Backs the Version/Status columns on the compute-aggregates admin page.
 */
import { emptySplitApi } from '../../../store/emptyApi';

export type AggregateVersionStatus =
  | 'current'
  | 'patch_behind'
  | 'minor_behind'
  | 'major_behind'
  | 'missing';

export type AggregateVersionAction = 'none' | 'recompute_optional' | 'auto_pending';

export interface AggregateVersionEntry {
  aggregate_type: number;
  name: string;
  current_version: string;
  computed_version: string | null;
  status: AggregateVersionStatus;
  action: AggregateVersionAction;
}

export interface AggregateVersionHealthResponse {
  assessment_period_id: number;
  aggregates: AggregateVersionEntry[];
  totals: Record<AggregateVersionStatus, number>;
}

export const AGGREGATE_VERSIONS_TAG = 'AggregateVersions' as const;

const apiWithTag = emptySplitApi.enhanceEndpoints({
  addTagTypes: [AGGREGATE_VERSIONS_TAG],
});

const aggregateVersionsApi = apiWithTag.injectEndpoints({
  endpoints: build => ({
    aggregateVersionHealth: build.query<AggregateVersionHealthResponse, { assessmentPeriodId: number }>({
      query: ({ assessmentPeriodId }) => ({
        url: '/api/portal/v1/assessments/aggregate-versions/',
        params: { assessment_period_id: assessmentPeriodId },
      }),
      providesTags: [AGGREGATE_VERSIONS_TAG],
    }),
  }),
  overrideExisting: false,
});

export const { useAggregateVersionHealthQuery } = aggregateVersionsApi;
export default aggregateVersionsApi;
